import Sprite from '_pixiSrc/display/Sprite';
import { APP } from '_pixiSrc/globals';

/**
* @class ScreenLocker
* @memberOf module:display
* @augments Sprite
* @classdesc ScreenLocker creates block with slightly darkened background
*/
class ScreenLocker extends Sprite {
    /**
   * @param {Number} [backColor=0X000000] background color in hexa decimal value
   * @param {Number} [fadeValue=0.8] alpha value for background
   */
    constructor(backColor = 0X000000, fadeValue = 0.2) {
        super();

        this.zIndex = 10000;
        this.backColor = backColor;
        this.fadeValue = fadeValue;

        this._addBackground();
        APP.layout.on('fitlayout', this.resizeScreenLocker, this); // handle screen resize event to resize screen locker
    }

    /**
   * @name _addBackground
   * @description add background of screen locker as current screen size.
   */
    _addBackground() {
        this.background = new PIXI.Graphics();
        this.resizeScreenLocker(APP.layout.calculatedSize);
        this.addChild(this.background);

        this.on('pointerclick', clickBlocker);
        this.on('mousedown', clickBlocker);
        this.on('mouseup', clickBlocker);

        function clickBlocker() {
            return false;
        }
    }

    /**
   * @name resizeScreenLocker
   * @param  {Object} calculatedSize current screen width and height
   * @description resize screen locker background as screen resize.
   */
    resizeScreenLocker(calculatedSize) {
        const screenLockerWidth = calculatedSize.screenWidth * 2 || 1280;
        const screenLockerHeight = calculatedSize.screenHeight * 2 || 1280;
        this.background.clear();
        this.background.beginFill(this.backColor, this.fadeValue);
        this.background.drawRect(-screenLockerWidth / 2, -screenLockerHeight / 2, screenLockerWidth, screenLockerHeight);
        this.background.endFill();
    }

    /**
     * @name safeRemove
     * @description remove black background and fitlayout
     */
    safeRemove() {
        APP.layout.off('fitlayout', this.resizeScreenLocker, this);
        super.safeRemove();
    }
}
export default ScreenLocker;
